import { render, staticRenderFns } from "./Masks.vue?vue&type=template&id=6034eb12"
import script from "./Masks.vue?vue&type=script&lang=js"
export * from "./Masks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports